import React from 'react';
import * as _ from 'lodash'
import componentServices from '../componentServices';
import * as actions from '../actions';
import util from '../util';
import enums from '../enum';
import { CurrencyInput, Header, JobCostLockable, NumericInput, PinnableStats } from './sharedComponents';

class CustomCost extends React.Component<any,any> {
	onValueChange (autoSave, e) {
		this.props.onChange(e.target.value, autoSave);
	}

	render () {
		const { rowClasses } = this.props;

		return (
			<tr className={ rowClasses.join(' ') }>
				<td />
				<td>Custom cost</td>
				<td className="right"><CurrencyInput placeholder="$0.00" autoCorrect="off" value={this.props.value} onChange={this.onValueChange.bind(this, false)} onBlur={this.onValueChange.bind(this, true)} /></td>
				<td />
			</tr>
		);
	}
}

export default class JobCostEditDelivery extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();

		this.onUpdateDeliveryCost = this.onUpdateDeliveryCost.bind(this);
		this.pinStats = this.pinStats.bind(this);
	}

	UNSAFE_componentWillReceiveProps () {
		this.setState(this.getStateFromProps());
	}

	getStateFromProps () {
		const state = _.assign({}, this.state);
		const { jobCost } = this.props;
		const deliveryVersion = jobCost.getSettingValue(enums.jobCostSettingGroups.General, 'deliveryConfigVersion', undefined, 'v1');
		const configName = `delivery-${deliveryVersion}`;
		const deliveryConfig = componentServices.store.getIn(['model', 'config', _.camelCase(configName)]);

		if (!deliveryConfig) {
			actions.fetchConfig({ name: configName });
		}
		else {
			state.deliveryConfig = deliveryConfig;
		}

		return state;
	}

	_getLineItems (jobCost) {
		const result = {
			deliveryLineItem: {} as any,
			cabinetCountLineItems: [] as any[]
		};

		jobCost.withStrictFilters((strictJobCost) => {
			result.deliveryLineItem = _.find(strictJobCost.lineItems, { type: 'delivery' }) as any;
			result.cabinetCountLineItems = _.filter(strictJobCost.lineItems, { isCabinetCount: true }) as any[];
		});

		return result;
	}

	onUpdateDeliveryCost (totalCost, autoSave) {
		const { jobCost: propJobCost } = this.props;
		const targetItems = this._getLineItems(propJobCost);

		if (targetItems.deliveryLineItem || totalCost) {
			this.props.updateModel((jobCost, lineUpdateCallback) => {
				const added = !targetItems.deliveryLineItem;

				targetItems.deliveryLineItem = targetItems.deliveryLineItem || jobCost.createLineItem({ type: 'delivery', margin: jobCost.margin, quantity: 1 });

				targetItems.deliveryLineItem.cost = totalCost;

				if (added) {
					jobCost.lineItems.add(targetItems.deliveryLineItem);
				}

				lineUpdateCallback(targetItems.deliveryLineItem, 'cost');
			}, { autoSave: autoSave });
		}
	}

	onCabinetCountChange (autoSave, e) {
		const { jobCost: propJobCost } = this.props;
		const targetItems = this._getLineItems(propJobCost);

		const cabinetCount = Number(e.target.value);

		if (targetItems.deliveryLineItem || cabinetCount) {
			this.props.updateModel((jobCost, lineUpdateCallback) => {
				const added = !targetItems.deliveryLineItem;

				targetItems.deliveryLineItem = targetItems.deliveryLineItem || jobCost.createLineItem({ type: 'delivery', margin: jobCost.margin, quantity: 1 });

				targetItems.deliveryLineItem.pieceCount = cabinetCount;

				if (added) {
					jobCost.lineItems.add(targetItems.deliveryLineItem);
				}

				// pieceCount triggers jobCostActions calculations
				lineUpdateCallback(targetItems.deliveryLineItem, 'pieceCount');
			}, { autoSave: autoSave });
		}
	}

	onDeliverToChange (autoSave, e) {
		const { jobCost: propJobCost } = this.props;
		const targetItems = this._getLineItems(propJobCost);
		const cabinetCount = targetItems.cabinetCountLineItems.length ? Math.ceil(_.reduce(targetItems.cabinetCountLineItems, (sum, item) => sum + item.quantity, 0)) : targetItems.deliveryLineItem ? targetItems.deliveryLineItem.pieceCount : 0;

		const value = e.target.value;

		this.props.updateModel((jobCost, lineUpdateCallback) => {
			const added = !targetItems.deliveryLineItem;

			targetItems.deliveryLineItem = targetItems.deliveryLineItem || jobCost.createLineItem({ type: 'delivery', margin: jobCost.margin, quantity: 1 });

			targetItems.deliveryLineItem.orderNote = value;
			targetItems.deliveryLineItem.pieceCount = cabinetCount;
			targetItems.deliveryLineItem.cost = 0;

			if (added) {
				jobCost.lineItems.add(targetItems.deliveryLineItem);
			}

			// pieceCount triggers jobCostActions calculations
			lineUpdateCallback(targetItems.deliveryLineItem, 'pieceCount');
		}, { autoSave: autoSave });
	}

	getDeliveryData (optionName, cabinetCount) {
		const { deliveryConfig } = this.state;
		const result = {} as any;

		if (deliveryConfig) {
			const option = _.find(deliveryConfig.Retail.options, { name: optionName || '~' });
			if (cabinetCount) {
				_.forEach(deliveryConfig.Retail.pieceRanges, range => {
					if (cabinetCount >= range.min && cabinetCount <= range.max) {
						result.additionalCost = range.additionalCost;
						result.option = option;
						return false;
					}
				});
			}
		}

		return result;
	}

	pinStats () {
		actions.setPinnedStatState({ key: 'jcDelivery', isPinned: true });
	}

	render () {
		const { jobCost } = this.props;
		const { deliveryConfig } = this.state;
		const hasPinnedStats = !!componentServices.store.getIn(['viewState', 'pinnedStats', 'jcDelivery']);
		const targetItems = this._getLineItems(jobCost);
		const deliveryLineItem = targetItems.deliveryLineItem || jobCost.createLineItem({ type: 'delivery' });
		const cabinetCountLineItems = targetItems.cabinetCountLineItems;
		const cabinetCount = cabinetCountLineItems.length ? Math.ceil(_.reduce(targetItems.cabinetCountLineItems, (sum, item) => sum + item.quantity, 0)) : deliveryLineItem.pieceCount;
		const deliveryData = this.getDeliveryData(deliveryLineItem.orderNote, cabinetCount);
		const showCustom = (!!deliveryLineItem.orderNote && (!deliveryData.option || !!deliveryData.option.isCustom));
		const cabinetClassName = cabinetCountLineItems.length ? 'disabled' : '';
		const optionsLabel = deliveryConfig ? deliveryConfig.Retail.optionsLabel : 'Deliver to';
		const deliveryOptions:JSX.Element[] = [];
		let deliveryTd;

		if (deliveryConfig) {
			deliveryConfig.Retail.options.forEach(option =>{
				deliveryOptions.push(<option key={option.name} value={option.name}>{option.name}</option>);
			});

			if (deliveryOptions.length && deliveryConfig.Retail.optionsControl === 'select') {
				deliveryOptions.unshift(<option key="emptyOption" value="">Select</option>);
				deliveryTd = (<td className="right">
					<select value={ deliveryLineItem.viewValue('orderNote') } onChange={this.onDeliverToChange.bind(this, true)}>{ deliveryOptions }</select>
				</td>);
			}
			else {
				deliveryTd = (<td className="right">
					<input type="text" className="dataList" list="deliveryDataList" value={ deliveryLineItem.viewValue('orderNote') } placeholder="Enter or Select" onChange={this.onDeliverToChange.bind(this, false)} onBlur={this.onDeliverToChange.bind(this, true)} />
					<datalist id="deliveryDataList">
						{ deliveryOptions }
					</datalist>
				</td>);
			}
		}

		return (
			<section>
				<Header title="Delivery" />
				<div>
					<section className="expander expanded jobCostDelivery">
						<div className="inner">

							<table className="compact" cellPadding="0" cellSpacing="0">
								<tbody>
									<JobCostLockable jobCost={ jobCost }>{ ({ getClassName }) =>
										(<tr className={ getClassName() }>
											<td />
											<td>Number of Cabinets</td>
											<td className="right"><NumericInput className={cabinetClassName} placeholder="0" value={ util.reactVal(cabinetCount) } onChange={this.onCabinetCountChange.bind(this, false)} onBlur={this.onCabinetCountChange.bind(this, true)} /></td>
											<td />
										</tr>)
									}
									</JobCostLockable>
									<JobCostLockable jobCost={ jobCost }>{ ({ getClassName }) =>
										(<tr className={ getClassName() }>
											<td />
											<td>{ optionsLabel }</td>
											{ deliveryTd }
											<td />
										</tr>)
									}
									</JobCostLockable>
									{ !showCustom ? null : <JobCostLockable jobCost={ jobCost }>{ ({ getClassName }) => <CustomCost value={ deliveryLineItem.viewValue('cost') } rowClasses={ [getClassName()] } onChange={ this.onUpdateDeliveryCost } /> }</JobCostLockable> }
								</tbody>
							</table>
						</div>
					</section>
					{ hasPinnedStats ? <section className="stats total pinnable out" /> : null }
					<PinnableStats isPinned={ hasPinnedStats }>
						<section className={ hasPinnedStats ? 'stats total compact' : 'stats total pinnable'}>
							{ hasPinnedStats ? null : <button className="icon iconOnly pinItem" onClick={ this.pinStats }><span /></button> }
							<div className="cost column">
								{ util.formatAsCurrency(deliveryLineItem.cost) } <span>DELIVERY SUBTOTAL</span>
							</div>
						</section>
					</PinnableStats>
				</div>
			</section>
		);
	}
}
